<template>
  <div class="sidebar_container">
    <el-menu
      mode="vertical"
      unique-opened
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#FFF"
      router
      text-color="#202224"
      active-text-color="#3870E0"
    >
      <el-submenu v-for="(item,index) in routes" :index="item.path" :key="index" v-if="!item.hidden&&item.meta">
        <template slot="title">
          <svg-icon style="width: 14px;height: 14px;margin-right: 6px" v-if="item.meta&&item.meta.icon"
                    :icon-class="item.meta.icon"></svg-icon>
          <span slot="title">{{ item.meta.title }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="(child_item,index2) in item.children" v-if="!child_item.hidden" :index="child_item.path"
                        :key=index2>
            <svg-icon
              style="width: 14px;height: 14px;margin-right: 6px"
              v-if="child_item.meta&&child_item.meta.icon"
              :icon-class="child_item.meta.icon">
            </svg-icon>
            <span slot="title">
              {{ child_item.meta.title }}
            </span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <div class="toggleBar" :style="!sidebar.opened?'border-top: 1px solid #E5E7EB':'border-top:none'"
         @click="()=>{this.$store.dispatch('ToggleSideBar')}">
      <svg-icon
        class="toggleBar_icon"
        :icon-class="sidebar.opened?'menu_open':'menu_close'">
      </svg-icon>
<!--      <span v-if="!sidebar.opened">收起导航</span>-->
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'routers',
      'sidebar'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return this.sidebar.opened;
    }
  },
}
</script>
<style lang="scss" scoped>
.sidebar_container {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  .el-menu-item-group__title{
    padding: 0;
  }
  .toggleBar {
    cursor: pointer;
    margin: 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 56px;

    .toggleBar_icon {
      width: 24px;
      height: 24px;
    }

    span {
      width: 56px;
      height: 22px;
      font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: #202224;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
